import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=1edd0747&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1edd0747')) {
      api.createRecord('1edd0747', component.options)
    } else {
      api.reload('1edd0747', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=1edd0747&", function () {
      api.rerender('1edd0747', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/timesheet/Add.vue"
export default component.exports